import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "l-wrapper" }
const _hoisted_2 = { class: "l-wrapper_main" }
const _hoisted_3 = { class: "p-login" }
const _hoisted_4 = { class: "p-login-inner" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h1", { class: "p-login-heading-2" }, "エラー", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", {
  class: "p-login-text-block --no-mt",
  style: {"text-align":"center"}
}, [
  /*#__PURE__*/_createElementVNode("p", null, "この認証URLは有効ではございません。")
], -1)
const _hoisted_7 = { class: "p-login-text-block" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", null, "ページを閉じる", -1)
const _hoisted_10 = [
  _hoisted_9
]

import { ref } from 'vue';
import { domHelperUtils } from '@/utils/domHelper';

// ウィンドウを閉じる関数を追加

export default /*#__PURE__*/_defineComponent({
  __name: 'MailSecurityCertificationCompleteErrorView',
  setup(__props) {

function closeWindow() {
  window.close();
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("main", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("a", {
              class: "p-recommend-button --type-2 --width-set-1 t-decoration-none",
              href: "#",
              onClick: _withModifiers(closeWindow, ["prevent"])
            }, _hoisted_10, 8, _hoisted_8)
          ])
        ])
      ])
    ])
  ]))
}
}

})